<template>
  <div class="feed-block">
    <header class="title" tag="h2">{{ title }}</header>
    <ul>
      <li v-for="feed in feeds" :key="feed.id">
        <FeedBlockItem :feed="feed" />
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
interface Props {
  title: string;
  feeds: FeedSchema[];
}
defineProps({
  title: null,
  feeds: null
});
</script>
<style lang="scss" scoped>
.feed-block {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
  @include above('m') {
    width: 40rem;
  }
}
.title {
  @include font('l', 700, 'secondary');

  color: var(--color_neutral_800);
}
ul {
  display: flex;
  flex-direction: column;
  gap: var(--gap_m);
}
</style>
